<script lang="ts">
  import {createEventDispatcher} from "svelte"
  import {activeTags, tags} from "../../stores";

  const dispatch = createEventDispatcher()
</script>

<div class='filter'>
  {#each $tags as tag, i (i)}
    <input 
      id={`tag${i}`} 
      type="checkbox"
      name="tags"
      value={tag.slug}
      bind:group={$activeTags} 
      on:change ={() => dispatch('search')}
    >
    <label 
      for={`tag${i}`} 
      class="text-bold text-grey"
    >
      {tag.title}
      <span>
        <i class="icon-cross" />
      </span>
    </label>
  {/each}
</div>

<style lang="scss">
  .icon-cross {
    font-size: 10px;
    color: #576CED;

    &::before {
      margin: 0;
    }
  }

  .filter {
    display: flex; 
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-top: 8px;
    margin-bottom: 24px;
    gap: 8px;
    
    @media (max-width: 576px) {
      margin-bottom: 16px;
      overflow-x: scroll;
      overflow-y: hidden;
    }
  }

  label {
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    cursor: pointer;
    padding: 8px 12px;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    background: #EFF1FD;
    color: #22252C;
    border-radius: 12px;
    gap: 4px;

    > span {
      background: #FFFFFF;
    }

    &:active {
      animation: vibrate .2s infinite linear;
		  -moz-animation: vibrate .2s infinite linear;
		  -webkit-animation: vibrate .2s infinite linear;
		  -o-animation: vibrate .2s infinite linear;
    }
  }

  @keyframes vibrate {
    0% { transform: rotate(3deg) translateX(3px) }
    50% { transform: rotate(-3deg) translateX(-3px) }
    100% { transform: rotate(3deg) translateX(3px) }
  }

  input[type='checkbox'] {
    display: none;
  }
  input[type='checkbox']+label>span {
    display: none;
    border-radius: 4px;
    width: 16px;
    height: 16px;
  }
  input[type='checkbox']:checked+label {
    background: #576CED;
    color: #FFFFFF;
  }
  input[type='checkbox']:checked+label>span {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
